import { memo, useState } from 'react';
import './floatingMessage.scss';

export interface FloatingMessageProps {
    message: string;
    variant: string;
    cb?: () => void;
    timeOut?: number;
}

export interface FloatingMessageState extends FloatingMessageProps {
    isLoading: boolean;
}

const FloatingMessage = ({ message, variant, cb, timeOut = 3000 }: FloatingMessageProps) => {
    const [hidden, setHidden] = useState('');

    setTimeout(() => {
        setHidden(' hidden-msg');
        if (cb) {
            cb();
        }
    }, timeOut);

    return (
        <div data-testid="floating-message" className={"floating-message " + variant + hidden}>
            {message}
        </div>
    );
};

export default memo(FloatingMessage);